module.exports = __webpack_public_path__ + "media/stylesheets/images/martech/mail_case_01-fa103fb564b968dbf783ad4852ac2f2b.png";